package pl.finn.forms.enums

enum class ParticleFor(var value: String) {
  THIS("THIS"),
  ELEMENT_SIMPLE("ELEMENT_SIMPLE"),
  ELEMENT_COMPLEX("ELEMENT_COMPLEX"),
  GROUP("GROUP");

  override fun toString(): String {
    return value
  }
}